<template>
  <nav class="block mb-4 text-xs">
    <ol class="breadcrumb-list">
      <li class="breadcrumb-item">
        <router-link :to="{ name: 'index' }" class="hover:underline">首頁</router-link>
      </li>
      <li class="breadcrumb-item" v-if="$route.name === 'magazine'">
        <a>當月雜誌</a>
      </li>
      <!-- 館別 -->
      <li class="breadcrumb-item" v-if="$route.name !== 'magazine' && $route.name !== 'sale'">
        <router-link :to="{ name: navBarList.routerName, params:{ category: navBarList.category }, query: { type: navBarList.type, scope: navBarList.scope } }" class="hover:underline">
          {{ navBarList.title }}</router-link>
      </li>
      <!-- 雜誌類別 -->
      <li class="breadcrumb-item" v-if="magType && $route.params.category === 'magazine'">
        <router-link :to="{ name: 'productsList', params:{ category: navBarList.category }, query: { scope: '', type: navBarList.type, category:  magType.category_id } }" class="hover:underline">
          {{ magType.title }}</router-link>
      </li>
      <!-- 雜誌訂閱類別 -->
      <li class="breadcrumb-item" v-if="magPlanType && $route.name !== 'magazine' && $route.name !== 'sale'">
        <a>{{ magPlanType.title }}</a>
      </li>
      <!-- 叢書館 -->
      <li class="breadcrumb-item" v-if="bookPlanType && $route.name !== 'magazine' && ($route.query.type === 'BOOK' || $route.query.type === 'BOOK,DIGITAL') && $route.name !== 'sale'">
        <a>{{ bookPlanType.title }}</a>
      </li>
      <!-- 套書館 -->
      <li class="breadcrumb-item" v-if="packagePlanType && $route.name !== 'magazine' && ($route.query.type === 'PACKAGE' || $route.query.type === 'ITEM') && $route.name !== 'sale'">
        <router-link :to="{ name: 'productsList', params:{ category: 'package' }, query: { type: 'PACKAGE', scope: packagePlanType.scope } }" class="hover:underline">{{ packagePlanType.title }}</router-link>
      </li>
      <li class="breadcrumb-item" v-if="packsgeCildType && $route.name !== 'magazine' && $route.query.type === 'PACKAGE' && $route.name !== 'sale'">
        <a>{{ packsgeCildType.title }}</a>
      </li>

      <!-- 數位學習 -->
      <li class="breadcrumb-item" v-if="$route.name !== 'magazine' && $route.name !== 'sale' && $route.query.digiType && $route.query.digiType === 'APP'">
        <a>APP學習</a>
      </li>
      <li class="breadcrumb-item" v-if="$route.name !== 'magazine' && $route.name !== 'sale' && $route.query.digiType && $route.query.digiType === 'EBOOK'">
        <a>電子書</a>
      </li>

      <!-- 詳細頁名稱 -->
      <li class="breadcrumb-item" v-if="$route.name === 'detail' && productTitle && $route.name !== 'magazine' && $route.name !== 'sale' && productTitle.category_name && magParams">
        <router-link :to="{ name: 'productsList', params:{ category: magParams.toLowerCase() }, query: { type: productTitle.type, category:  productTitle.category_id } }" class="hover:underline">
        {{ productTitle.category_name }}</router-link>
      </li>
      <li class="breadcrumb-item" v-if="$route.name === 'detail' && productTitle && $route.name !== 'magazine' && $route.name !== 'sale' && productTitle.name">
        <a>{{ productTitle.name }}</a>
      </li>
      <!-- 活動頁 -->
      <li class="breadcrumb-item" v-if="$route.name === 'sale'">
        <a>{{ productTitle.name }}</a>
      </li>
    </ol>
  </nav>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
export default {
  name: 'Breadcrumb',
  data () {
    return {
      menuData: [
        { title: '最新優惠', routerName: 'productsList', category: 'recent' },
        { title: '雜誌館', routerName: 'magazine', category: 'magazine', type: 'MAGAZINE' },
        { title: '叢書館', routerName: 'productsList', category: 'book', type: 'BOOK' },
        { title: '套書館', routerName: 'productsList', category: 'package', type: 'PACKAGE' },
        { title: '套書館', routerName: 'productsList', category: 'item', type: 'PACKAGE' },
        { title: '點讀館', routerName: 'productsList', category: 'livepen', scope: 'livepen' },
        { title: '數位館', routerName: 'productsList', category: 'digital', type: 'MAGAZINE,DIGITAL' },
        { title: '下載專區', routerName: 'download', category: 'download' }
      ],
      bookTypeData: null
    }
  },
  props: {
    productTitle: {
      type: Object
    },
    category_type: {
      type: String,
      default: 'magazine'
    }
  },
  watch: {
    '$route.query.type' (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getData()
      }
    }
  },

  computed: {
    magParams () {
      if (!this.category_type) {
        if (this.category_type === 'PLAN') {
          return 'MAGAZINE'
        }
        return this.category_type
      }
      return null
    },

    navBarList () {
      if (!this.menuData || this.menuData.length < 1) return null

      if (this.productTitle) {
        let category = this.category_type

        if (category === 'plan') {
          category = 'magazine'
        }

        return this.menuData.find((item) => item.category === category) || this.menuData[0]
      } else if (this.$route.params.category) {
        return this.menuData.find((item) => item.category === this.$route.params.category) || this.menuData[0]
      }

      return this.menuData[0]
    },
    magType () {
      if (this.bookTypeData && this.$route.query.category) {
        return this.bookTypeData.filter((item) => item.category_id === Number(this.$route.query.category))[0]
      } else {
        return ''
      }
    },
    magPlanType () {
      if (this.$route.query.type === 'PLAN' && this.magType && this.magType.items) {
        return this.magType.items.filter((item) => item.scope === this.$route.query.scope)[0]
      } else if (this.$route.query.type === 'MAGAZINE,PHYSICAL' && this.magType && this.magType.items) {
        return this.magType.items.filter((item) => item.type === 'MAGAZINE,PHYSICAL')[0]
      } else {
        return ''
      }
    },
    bookPlanType () {
      if (this.bookTypeData && this.$route.query.type === 'BOOK') {
        return this.bookTypeData.filter((item) => item.category_id === this.$route.query.category)[0]
      } else if (this.bookTypeData && this.$route.query.type === 'BOOK,DIGITAL') {
        return this.bookTypeData.filter((item) => item.type === 'DIGITAL')[0]
      } else {
        return ''
      }
    },
    packagePlanType () {
      if (this.bookTypeData && this.$route.query.type === 'PACKAGE' && (this.$route.query.category || this.$route.query.scope)) {
        let ar = [146, 136, 137, 138, 134, 139, 135, 140, 147]
        if (ar.indexOf(this.$route.query.category) > -1 || this.$route.query.scope === 'smartpen_package_series') {
          return this.bookTypeData.filter((item) => item.scope === 'smartpen_package_series')[0]
        } else {
          return this.bookTypeData.filter((item) => item.scope === 'classic_package_series')[0]
        }
      } else if (this.bookTypeData && this.$route.query.type === 'ITEM' && this.$route.query.category) {
        return this.bookTypeData.filter((item) => item.type === 'ITEM')[0]
      } else {
        return ''
      }
    },
    packsgeCildType () {
      if (this.packagePlanType && this.packagePlanType.items) {
        return this.packagePlanType.items.filter((item) => item.category_id === this.$route.query.category)[0]
      } else {
        return ''
      }
    }
  },
  mounted () {
    this.$route.params.category ? this.getData() : null
  },
  methods: {
    async getData () {
      if (this.$route.name === 'productsList' || this.$route.name === 'detail' || this.$route.name === 'previewMagazine') {
        let path
        switch (this.$route.params.category) {
          case 'recent':
            path = '/menu/newbook'
            this.category = 'recent'
            break
          case 'magazine':
            path = '/menu/magazine'
            this.category = 'magazine'
            break
          case 'book':
            path = '/menu/book'
            this.category = 'book'
            break
          case 'package':
            path = '/menu/package'
            this.category = 'package'
            break
          case 'digital':
            path = '/menu/digital'
            this.category = 'digital'
            break
          case 'livepen':
            path = '/menu/livepen'
            this.category = 'livepen'
            break
        }
        let { data } = await axios.get(path)
        this.bookTypeData = data.menu.items
      }
    },
    toSale (id) {
      this.removeMenu()
      this.$router.push({ name: 'sale', params: { category: this.category }, query: { tag: id } })
    }
  }
}
</script>

<style lang="scss">
.breadcrumb-list {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  list-style: none;
  li {
    letter-spacing: 0.125rem;
    text-transform: uppercase;
    a {
      color: #888;
      text-decoration: none;
      transition: all 0.2s ease;
      &:hover {
        color: #333;
        text-decoration-color: #333;
      }
    }
  }
}
.breadcrumb-item + .breadcrumb-item::before {
    content: "/";
    display: inline-block;
    padding: 0 0.5rem;
    color: #d5d5d5;
}
</style>
